// 定义全局api接口地址，用于接收根据当前环境判读后使用的api-url地址
let apiUrl
var host = window.location.protocol + '//' + window.location.host
if (host.indexOf('localhost:') > -1) {
  host = 'https://test-gateway.yingxiong.com'
}
apiUrl = {
  gateUrl: host + '/cdp-gateway'
}

export {
  apiUrl
}
